const launchpadIDOs = [
  {
    tokenSymbol: 'KITTY',
    whiteLogo: 'kitty.png',
    darkLogo: 'kitty_logo_dark.svg',
    isCompleted: false,
    totalRaised: 562500,
    returnToATH: 15,
    participants: 0,
    startDate: '12.17.2021',
    startTimestamp: 1639764000,
    endTimestamp: 1640649540,
    tokenPrice: 0.045,
    soldTokenAmount: '0',
    distributedTokenAmount: '12.5M',
    saleProgress: '0',
    status: 'In Progress',
    link: '/launchpad-kitty',
    title: 'Binary Cat',
    allocation: 0
  },
  {
    tokenSymbol: 'BOOFI',
    whiteLogo: 'boofi.svg',
    darkLogo: 'boofi_logo_dark.png',
    isCompleted: true,
    totalRaised: 250000,
    returnToATH: 15,
    participants: 2256,
    startDate: '09.24.2021',
    startTimestamp: 1632409200,
    endTimestamp: 1633604400,
    tokenPrice: 0.125,
    soldTokenAmount: '1.96M',
    distributedTokenAmount: '2M',
    saleProgress: '100',
    status: 'Launched',
    link: '/launchpad-boofi',
    title: 'Boofinance',
    allocation: 0
  },
  {
    tokenSymbol: 'SHERPA',
    whiteLogo: 'sherpa.png',
    darkLogo: 'sherpa_logo_dark.png',
    isCompleted: true,
    totalRaised: 91500,
    participants: 595,
    returnToATH: 31,
    startDate: '07.19.2021',
    startTimestamp: 1626620400,
    endTimestamp: 1627984800,
    tokenPrice: 0.15,
    soldTokenAmount: '536K',
    distributedTokenAmount: '600K',
    saleProgress: '100',
    status: 'Launched',
    link: '/launchpad-sherpa',
    title: 'Sherpa',
    allocation: 0
  },
  {
    tokenSymbol: 'KACY',
    whiteLogo: 'kacy.png',
    darkLogo: 'kassandra_logo_dark.png',
    isCompleted: false,
    totalRaised: 350000,
    returnToATH: 15,
    participants: 0,
    startDate: '01.18.2022',
    startTimestamp: 1642536000,
    endTimestamp: 1643155200,
    tokenPrice: 0.7,
    soldTokenAmount: '0',
    distributedTokenAmount: '500K',
    saleProgress: '0',
    status: 'In Progress',
    link: '/launchpad-kassandra',
    title: 'Kassandra',
    allocation: 0
  },
]

export default launchpadIDOs